import Media from 'jsmediatags';
import { TagType } from 'jsmediatags/types';
import { fileSystemStore } from '@/store';
import { AlbumEntry } from '@/store/MusicStore';

function ReadMP3Tags(file: File): Promise<TagType> {
  return new Promise((resolve, reject) => {
    Media.read(file, {
      onSuccess: resolve,
      onError: reject
    });
  });
}

async function loadImage(dataString: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = dataString;
    img.onload = () => resolve(img);
    img.onerror = reject;
  });
}

interface ArtworkBlob {
  blob: Blob;
  width: number;
  height: number;
}

export async function generateDataUrl(album: AlbumEntry): Promise<string> {
  const first = album.songs[0];
  const file = await fileSystemStore.resolveFile(first.path);
  const { tags } = await ReadMP3Tags(file);
  if (tags.picture) {
    const encoded = btoa(tags.picture.data.map(e => String.fromCharCode(e)).join(''));
    return `data:${tags.picture.format};base64,${encoded}`;
  } else {
    return null;
  }
}

export async function generatePng(album: AlbumEntry): Promise<ArtworkBlob> {
  const slug = await generateDataUrl(album);
  if (slug) {
    const img = await loadImage(slug);

    // An odd choice of words...
    let { width, height } = img;
    const maxSize = 300;
    if (width > maxSize) {
      const shrink = width / maxSize;
      width /= shrink;
      height /= shrink;
    }
    if (height > maxSize) {
      const shrink = height / maxSize;
      width /= shrink;
      height /= shrink;
    }
    const canvas = new OffscreenCanvas(width, height);
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, width, height);
    return {
      blob: await canvas.convertToBlob({
        type: 'image/png'
      }),
      width,
      height
    };
  }

  return null;
}

/**
 * Constructs a url for the provided albums cover art.
 * If not cached, the artwork will be extracted from the first song in
 * the album.
 * @param album Album to generate artwork for
 */
export async function getAlbumArt(album: AlbumEntry): Promise<string> {
  const filename = album.title.replace(/[^a-zA-Z\s0-9.:]/g, '-') + '.png';

  const cache = await fileSystemStore.setupMetaDirectory();
  if (await fileSystemStore.fileExists(cache, filename)) {
    const file = await cache.getFile(filename);
    return URL.createObjectURL(await file.getFile());
  } else {
    const art = await generatePng(album);
    if (art) {
      const { blob, width, height } = art;
      const outFile = await cache.getFile(filename, { create: true });
      const writer = await outFile.createWritable({ keepExistingData: false });
      await writer.truncate(0);
      await writer.write(blob);
      await writer.getWriter().close();
      // await writer.abort();
      const file = await outFile.getFile();
      console.log('Did the thing', album.title, width, height, URL.createObjectURL(file));
      return URL.createObjectURL(file);
    } else {
      return '';
    }
  }
}
